import { createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import * as fromUser from '../reducers/user.reducer';

const selectUser = (state: fromApp.AppState) => state.user;

export const selectUserCurrentUser = createSelector(selectUser, (state: fromUser.State) => state.currentUser);

export const selectUserIsAdmin = createSelector(selectUser, (state: fromUser.State) => state.isAdmin);
